import { useTranslation } from 'react-i18next'
import IconCarbonCatalog from '@/shared/icons/IconCarbonCatalog'
import IconCarbonLifebuoy from '@/shared/icons/IconCarbonLifebuoy'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const useResources = (country: string) => {
  const { t } = useTranslation()

  const resources = [
    {
      key: 'guide',
      href: t('subscriptionForm:resources.link'),
      label: t('subscriptionForm:resources.title'),
      icon: IconCarbonCatalog,
    },
    {
      key: 'sos',
      href: t('subscriptionForm:resources.sos_link'),
      label: t('subscriptionForm:resources.sos_title'),
      icon: IconCarbonLifebuoy,
    },
  ]

  // @ts-ignore
  return { t, resources, hidden: !modulesConfig[country]?.rightPanel?.resources }
}

export default useResources
